import { module } from 'angular';
import App from '../../../app';

class SCR0504Controller {
	
	constructor ($scope, $uibModalInstance, httpService, utilService, gridService, userService,
			codeService, popupService, data){
		this.$scope = $scope;
		this.$uibModalInstance = $uibModalInstance;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.codeService = codeService;
		this.popupService = popupService;
		this.userService = userService;
		
		this.initWindow(840, 460);
		this.initCode();
		this.initText();
		
		this.intrfc = {};
		this.data = data;
		this.addMsg = {};
		this.addMsg.msgVersion = "1";
		this.initApp();
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = $.extend({}, bxMsg.getMessages('common'), bxMsg.getMessages('manageMsg'));		
	}
	
	initCode(){
		this.tranDscdAllList = this.codeService.getCodesByCdIdFromMem('TRAN_DSCD');
		this.syncDscdList = this.codeService.getCodesByCdIdFromMem('CHL_DSCD');
		this.msgTypeList = this.codeService.getCodesByCdIdFromMem('MSG_TYPE');
	}

	initApp() {
		if($.cookie('lvCd')){
			let lvCdList = $.cookie('lvCd').split('/');
			this.addMsg.lv1Cd = lvCdList[0];
			this.addMsg.lv2Cd = lvCdList[1];
			this.addMsg.lv3Cd = lvCdList[2];
		}
	}
	
	setMsgOption(){
		if(_.isEmpty(this.addMsg)) {
			this.msgTypes = [];
			return;
		}
		
		switch(this.addMsg.chlDscd){
			case 'INTERNAL':
				switch(this.addMsg.trxDscd){
				case 'ONLINE':
					this.msgTypes = this.msgTypeList.filter(v => v.cdVal == 'IV' || v.cdVal == 'STH' );
					break;
				case 'BATCH':
					this.msgTypes = this.msgTypeList.filter(v => v.cdVal == 'BATH' || v.cdVal == 'BATB' || v.cdVal == 'BATT' );
					break;
				}
				break;
			case 'EXTERNAL':
				switch(this.addMsg.trxDscd){
				case 'ONLINE':
					this.msgTypes = this.msgTypeList.filter(v => v.cdVal == 'IV' || v.cdVal == 'CH' || v.cdVal == 'ISOH' || v.cdVal == 'ISOB');
					break;
				case 'BATCH':
					this.msgTypes = this.msgTypeList.filter(v => v.cdVal == 'BATH' || v.cdVal == 'BATB' || v.cdVal == 'BATT' );
					break;
				}
				break;
		}
		
	}
	
	closeModal(isOk){
		
		if(isOk){
			const userInfo = this.userService.getUser();			
			if(userInfo.roleId != 'Administrator' && this.addMsg.chlDscd == 'INTERNAL' && this.addMsg.trxDscd == 'ONLINE' && this.addMsg.msgDscd == 'STH'){
				this.popupService.simpleAlert(this.$scope, this.text.addCommonHeaderMsg);
				return;
			}
			
			if(!this._checkValid()) return;
			this.createMsgId();
		} else {
			this.$uibModalInstance.dismiss();
		}
	}

	createMsgId(){
		const msgIdCreateDto = this.utilService.clone(this.addMsg);
		
		this.httpService.post('/msglayouts/msgidcreate', msgIdCreateDto)
						.then(res => {
							if (res.isError) {
								this.popupService.detailAlert(this.$scope, res.data.message, res.data.stackTrace);
								return;
							}
							this.addMsg.msgLayoutId = res.msgLayoutId;
							this.$uibModalInstance.close(this.addMsg);
						});
	}
	
	selectApplication(){
		this.popupService.openModal('SCR1402')
						.then((codes) => {
							this.addMsg.lv1Cd = "";
							this.addMsg.lv2Cd = "";
							this.addMsg.lv3Cd = "";
							
							codes.map((code, index) =>{
								if(index > 2) return;
								this.addMsg[`lv${index +1}Cd`] = code.appCd;
							});
							
							$.cookie(`lvCd`, this.addMsg.lv1Cd + '/' + this.addMsg.lv2Cd + '/' + this.addMsg.lv3Cd, { expires: 7 });
						})
						.catch(()=>{})
	}
	
	selectSndSys(){
		this.popupService.openModal('SCR1302')
						.then((sndSys) => {
							this.addMsg.sndSysNm = sndSys.sysNm;
							this.addMsg.sendSysCd = sndSys.sysCd;
						})
						.catch(()=>{})
	}
	
	selectRcvSys(){
		this.popupService.openModal('SCR1302')
						.then((rcvSys) => {
							this.addMsg.rcvSysNm = rcvSys.sysNm;
							this.addMsg.receiveSysCd = rcvSys.sysCd;
						})
						.catch(()=>{})
	}
	
	openBizCdPopup(){
		this.popupService.openModal('SCR1702')
						 .then(data => {this.addMsg.extrnlBizNm = data.bizCd})
						 .catch(()=>{});
	}
	
	chgTrxDscd(trxCd){
		if(trxCd == "ONLINE"){
			this.syncDscdList = this.codeService.getCodesByCdIdFromMem('SYNC_DSCD_FEP');
		}else{
			this.syncDscdList = this.codeService.getCodesByCdIdFromMem('SYNC_DSCD');
		}
	}
	
	_checkValid(){
		if(_.isEmpty(this.addMsg.lv3Cd)){
			this.openAlert(this.text.emptyLv3Cd);
			return false;
		} else if(_.isEmpty(this.addMsg.chlDscd)){
			this.openAlert(this.text.emptyChlDscd2);
			return false;
		} else if(_.isEmpty(this.addMsg.trxDscd)){
			this.openAlert(this.text.emptyTrxDscd2);
			return false;
		} else if(_.isEmpty(this.addMsg.msgDscd)){
			this.openAlert(this.text.emptyMsgDscd2);
			return false;
		} else if(this.addMsg.chlDscd == 'INTERNAL' && this.addMsg.trxDscd == 'ONLINE' && _.isEmpty(this.addMsg.sendSysCd)){
			this.openAlert(this.text.emptySendSysCd);
			return false;
		} else if(this.addMsg.chlDscd == 'INTERNAL' && this.addMsg.trxDscd == 'ONLINE' && _.isEmpty(this.addMsg.receiveSysCd)){
			this.openAlert(this.text.emptyReceiveSysCd);
			return false;
		} else if(this.addMsg.chlDscd == 'EXTERNAL' && this.addMsg.trxDscd == 'ONLINE' && _.isEmpty(this.addMsg.extrnlBizNm)){
			this.openAlert(this.text.emptyExtrnlBizNm2);
			return false;
		} else if(this.addMsg.chlDscd == 'EXTERNAL' && _.isEmpty(this.addMsg.msgVersion)){
			this.openAlert(this.text.emptyMsgVersion2);
			return false;
		} else if(this.addMsg.chlDscd == 'EXTERNAL' && this.addMsg.trxDscd == 'ONLINE'){
			if(this.addMsg.msgDscd == 'IV' && _.isEmpty(this.addMsg.msgNumber) || this.addMsg.msgDscd == 'ISOB' && _.isEmpty(this.addMsg.msgNumber)){
				this.openAlert(this.text.emptyMsgNumber);
				return false;				
			}
		} else if(this.addMsg.trxDscd == 'BATCH' && _.isEmpty(this.addMsg.fileId)){
			this.openAlert(this.text.emptyFileId2);
			return false;
		} 
		
		if(this.addMsg.chlDscd == 'EXTERNAL') {
			if(this.addMsg.msgDscd == 'IV' || this.addMsg.msgDscd == 'ISOB') {
//				if(isNaN(Number(this.addMsg.msgNumber)) || this.addMsg.msgNumber.length !== 4) {
//					this.openAlert(this.text.msgNoLengthMsg);
//					return false;
//				}
				
				if(!/^[a-zA-Z0-9]+$/.test(this.addMsg.msgNumber)){
					this.openAlert(this.text.msgNoValid);
					return false;
				}
				
				if(isNaN(Number(this.addMsg.msgVersion)) || this.addMsg.msgVersion.length > 2) {
					this.openAlert(this.text.verLengthMsg);
					return false;
				}
			}else if(this.addMsg.msgDscd == 'ISOH' || this.addMsg.msgDscd == 'CH') {
				if(isNaN(Number(this.addMsg.msgVersion)) || this.addMsg.msgVersion.length > 2) {
					this.openAlert(this.text.verLengthMsg);
					return false;
				}
			}
		}
		
		return true;
	}
	
	openAlert(alertBody){
		this.popupService.simpleAlert(this.$scope, alertBody);
	}
	
	getLvCd(intrfccoms) {
		let lvCd = '';
		
		if(intrfccoms) {
			if(intrfccoms.lv1Cd) {
				lvCd = intrfccoms.lv1Cd;
			}
			
			if(intrfccoms.lv2Cd) {
				lvCd += '/' + intrfccoms.lv2Cd;
			}
			
			if(intrfccoms.lv3Cd) {
				lvCd += '/' + intrfccoms.lv3Cd;
			}	
		}
		
		return lvCd;
	}
}

module(App.name).controller('SCR0504Controller', SCR0504Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0504/SCR0504.controller.js